import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import styles from './index.module.scss';
import { scrollCardMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';
import ScrollStickyVideo from '@/components/ScrollStickyVideo';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import { SCROLL_CARD_ARR } from '@/componentsH5/EcoCreditsDay/components/AnchorTabs/constant';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
import { signupCookie } from '@/utils/cookies/signupCookie';
const { EFPic } = createEFPic('/media/ecocredits-day/pc/');

export default function ScrollCard() {
    const { locale } = useRouter();
    const scrollList = scrollCardMap[locale as keyof typeof scrollCardMap] || scrollCardMap.jp;
    const { t } = useLang('ecocreditsday');

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.scroll-card', //触发元素
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            offset: 0, //从开始点滚动多少px触发,可为负数
            duration: '150%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineA1 = new TimelineMax();
        const tweenZ1 = TweenMax.to('.scroll-card-a > div > div > div', 0.25, { opacity: 0, scale: 1.2 });
        const tweenA1 = TweenMax.to('.scroll-card .scroll-item:nth-child(1)', 0.25, { opacity: 1, scale: 1 });
        timelineA1.add(tweenZ1, 0).add(tweenA1, 0.1);
        if (SCROLL_CARD_ARR.includes(locale as string)) {
            const tweenA3 = TweenMax.to('.scroll-card .scroll-item:nth-child(1) .left-img-in', 0.5, { opacity: 0, rotateY: 90 });
            const tweenA4 = TweenMax.to('.scroll-card .scroll-item:nth-child(1) .right-content', 0.5, { opacity: 0 });
            const tweenA5 = TweenMax.to('.scroll-card .scroll-item:nth-child(1)', 0.5, { zIndex: 80 });
            const tweenB1 = TweenMax.to('.scroll-card .scroll-item:nth-child(2) .left-img-in', 0.5, { scale: 1, opacity: 1 });
            const tweenB2 = TweenMax.to('.scroll-card .scroll-item:nth-child(2) .right-content', 0.5, { opacity: 1, y: -80 });
            const tweenB3 = TweenMax.to('.scroll-card .scroll-item:nth-child(2) .left-img-in', 0.5, { rotateY: 90, opacity: 0 });
            const tweenB4 = TweenMax.to('.scroll-card .scroll-item:nth-child(2) .right-content', 0.5, { opacity: 0 });
            const tweenB5 = TweenMax.to('.scroll-card .scroll-item:nth-child(2)', 0.5, { zIndex: 79 });
            const tweenC1 = TweenMax.to('.scroll-card .scroll-item:nth-child(3) .left-img-in', 0.5, { scale: 1, opacity: 1 });
            const tweenC2 = TweenMax.to('.scroll-card .scroll-item:nth-child(3) .right-content', 0.5, { opacity: 1, y: -80 });
            timelineA1
                .add(tweenA3, 0.5)
                .add(tweenA4, 0.5)
                .add(tweenA5, 0.5)
                .add(tweenB1, 0.75)
                .add(tweenB2, 0.75)
                .add(tweenB3, 1.5)
                .add(tweenB4, 1.5)
                .add(tweenB5, 1.5)
                .add(tweenC1, 1.75)
                .add(tweenC2, 1.75);
        }
        sceneA1.setTween(timelineA1);
        controllerDay.addScene(sceneA1);

        return () => {
            sceneA1 && sceneA1.destroy(true);
        };
    }, []);

    const handleClick = (item: any) => {
        if (locale !== 'jp') {
            if (item.naGtm) {
                gtm.push({
                    product_name: 'none',
                    event_name: 'buy',
                    position: 'Ecocredits-day',
                });
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'ecocredits_button',
                    type: locale === 'kr' ? 'Register' : 'Other',
                    list_name: t(`pageTabs.tab2`),
                    button_name: item.btnText,
                });
            }
        }
        if (locale === 'jp') {
            signupCookie?.({
                sector_name: t(`pageTabs.tab2`),
                entry_position: 4,
            });
        }
        window.open(item.btnLink);
    };

    return (
        <>
            <div className={`${styles.scrollCarda} scroll-card-a`}>
                <ScrollStickyVideo height={100} delayRatio={0} scrollRatio={4} url={handleDynamicPath('/media/ecocredits-day/pc/programme.mp4')} />
            </div>
            <div className={`${styles.scrollCard} scroll-card`} style={{ zIndex: 9 }}>
                <div className="scroll-box">
                    {scrollList.map((item: Record<string, any>, i) => (
                        <div className="scroll-item" key={i}>
                            <div className="left-img">
                                <div className="left-img-in">
                                    <EFPic name={item.src} />
                                </div>
                            </div>
                            <div className="right-content">
                                <div className="right-content-in">
                                    <div className="sub-title">{item.subTitle}</div>
                                    <div className="title">{item.title}</div>
                                    <div className="desc-list">
                                        {item?.desc?.map((val: string, index: number) => (
                                            <div className="desc-item" key={index}>
                                                {val}
                                            </div>
                                        ))}
                                    </div>
                                    {item.btnText && (
                                        <div className="bottom-btn" onClick={() => handleClick(item)}>
                                            <CommonButton disabledAni padding="10px 15px" borderRadius="8px" startOffsest={500}>
                                                <div className="btn-text">
                                                    {item.btnText}
                                                    <div className="btn-svg"></div>
                                                </div>
                                            </CommonButton>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
